import { Icon } from "semantic-ui-react";

import { useCan } from "components";
import "components/AdvisedCriticalHistory/components/AdvisedCriticalHistoryTable/components/AdvisedCriticalHistoryActions/AdvisedCriticalHistoryActions.scss";
import { AdvisedCriticalHistoryActionsSelector } from "components/AdvisedCriticalHistory/components/AdvisedCriticalHistoryTable/components/AdvisedCriticalHistoryActions/components";
import { ACL_ACTIVITIES, ACL_RESOURCES } from "models";
import { QuestionResultStatusSelector } from "modules/AppointmentDetails/components/Checks/components/Check/components/QuestionResults/components";
import { useQuestionResultMutation } from "modules/AppointmentDetails/hooks";
import { parseQuestionResultAttachments } from "modules/AppointmentDetails/utils";

import type { Appointment } from "models";
import type { QuestionResult } from "models/QuestionResult";

type AdvisedCriticalHistoryActionsProps = {
  questionResult: QuestionResult;
  toggleShowMedia?: (id: number) => void;
  onUpdateHiddenItems: () => void;
  appointment?: Appointment;
  onInterventionAddSuccess: () => void;
};

export const AdvisedCriticalHistoryActions = ({
  questionResult,
  appointment,
  toggleShowMedia,
  onUpdateHiddenItems,
  onInterventionAddSuccess
}: AdvisedCriticalHistoryActionsProps) => {
  const questionResultMutation = useQuestionResultMutation();
  const canUpdateQuestionResults = useCan(ACL_ACTIVITIES.Update, ACL_RESOURCES.CarCheckQuestionResults);

  const attachments = parseQuestionResultAttachments(questionResult);

  const handleVisibilityInHistoryItems = async () => {
    await questionResultMutation.mutateAsync({ ...questionResult, is_hidden_in_history: !questionResult.is_hidden_in_history });
    onUpdateHiddenItems();
  };

  return (
    <div className="AdvisedCriticalHistory-AdvisedCriticalHistoryActions">
      <div className="status-container">
        {attachments.length > 0 && toggleShowMedia && (
          <div onClick={() => toggleShowMedia(questionResult.id)}>
            <Icon className="images grey pointer" size="small" />
            <p>
              <small>{attachments.length}</small>
            </p>
          </div>
        )}
        <QuestionResultStatusSelector questionResult={questionResult} disabled />

        <AdvisedCriticalHistoryActionsSelector questionResult={questionResult} appointment={appointment} onInterventionAddSuccess={onInterventionAddSuccess} />
      </div>
      <div className="hidden-items-button">
        <Icon
          className={`clock rotate left ${questionResult.is_hidden_in_history ? "green" : "grey"}`}
          onClick={canUpdateQuestionResults ? handleVisibilityInHistoryItems : undefined}
        />
      </div>
    </div>
  );
};
